import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=818f689e"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('818f689e')) {
      api.createRecord('818f689e', component.options)
    } else {
      api.reload('818f689e', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=818f689e", function () {
      api.rerender('818f689e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/Carousel.vue"
export default component.exports